import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import UiIcon from './UiIcon.vue';
import ThemeControl from './ThemeControl.vue';
import { setLocale } from '@/locales';
export default {
  name: 'WorkspaceShell',
  components: {
    UiIcon,
    ThemeControl
  },
  data: () => ({
    menuOpen: false,
    isMobile: false,
    nav: [{
      path: '/',
      name: 'home',
      icon: 'upload',
      label: 'dashboardTabs.fileUpload'
    }, {
      path: '/dashboard',
      name: 'dashboard',
      icon: 'grid',
      label: 'dashboardTabs.fileManagement'
    }, {
      path: '/customerConfig',
      name: 'customerConfig',
      icon: 'users',
      label: 'dashboardTabs.userManagement'
    }, {
      path: '/systemConfig',
      name: 'systemConfig',
      icon: 'settings',
      label: 'dashboardTabs.systemSettings'
    }]
  }),
  computed: {
    enabled() {
      return this.nav.some(item => item.name === this.$route.name);
    },
    visibleNav() {
      return this.$store.getters.adminLoggedIn ? this.nav : this.nav.filter(item => item.name === 'home');
    },
    currentLabel() {
      return this.nav.find(item => item.name === this.$route.name)?.label || 'modern.workspace';
    },
    siteName() {
      return this.$store.getters.userConfig?.siteTitle || 'ImgHub';
    },
    customBrandLink() {
      return this.$route.name === 'home' ? this.$store.getters.userConfig?.logoLink : null;
    },
    ownerName() {
      return this.$store.getters.userConfig?.ownerName || 'Sanyue';
    },
    ownerInitial() {
      return this.ownerName.slice(0, 1).toUpperCase();
    },
    pageEyebrow() {
      return {
        dashboard: 'YOUR LIBRARY',
        customerConfig: 'PEOPLE & ACCESS',
        systemConfig: 'PREFERENCES'
      }[this.$route.name];
    }
  },
  watch: {
    '$route.fullPath'() {
      this.menuOpen = false;
    },
    menuOpen(value) {
      if (value) this.$nextTick(() => this.$el.querySelector('.workspace-nav-link')?.focus());
    }
  },
  mounted() {
    this.media = window.matchMedia('(max-width: 900px)');
    this.resize();
    this.media.addEventListener('change', this.resize);
    window.addEventListener('keydown', this.onKeydown);
  },
  beforeUnmount() {
    this.media.removeEventListener('change', this.resize);
    window.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    resize() {
      this.isMobile = this.media.matches;
      if (!this.isMobile) this.menuOpen = false;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    onKeydown(event) {
      if (!this.menuOpen) return;
      if (event.key === 'Escape') {
        this.closeMenu();
        this.$refs.menuButton?.focus();
      }
      if (event.key === 'Tab') {
        const links = Array.from(this.$el.querySelectorAll('.workspace-sidebar a'));
        if (event.shiftKey && document.activeElement === links[0]) {
          event.preventDefault();
          links.at(-1)?.focus();
        } else if (!event.shiftKey && document.activeElement === links.at(-1)) {
          event.preventDefault();
          links[0]?.focus();
        }
      }
    },
    changeLanguage() {
      setLocale(this.$i18n.locale === 'zh-CN' ? 'en' : 'zh-CN');
    }
  }
};